import { FunctionComponent } from "react";
import { NEATTData } from "src/utils/types/UserTypes";

interface IEmploymentInfoDisplayProps {
    employmentInfo: NEATTData['ei'];
}

const EmploymentInfoDisplay: FunctionComponent<IEmploymentInfoDisplayProps> = ({ employmentInfo }) => (
    <div className="w-full">
        <p className="mb-3"><span className="font-medium">Has Additional Income:</span> {employmentInfo.additionalIncome}</p>
        <p className="mb-3"><span className="font-medium">Living Status:</span> {employmentInfo.livingStatus}</p>
        <p className="mb-3"><span className="font-medium">Address Duration:</span> {employmentInfo.addressDuration}</p>
        <p className="mb-3"><span className="font-medium">Expects Income Change (1yr):</span> {employmentInfo.changesToIncomeOverYear}</p>
        <p className="mb-3"><span className="font-medium">Consents to Documentation:</span> {employmentInfo.documentationConsent}</p>
        <p className="mb-3"><span className="font-medium">Employment Status:</span> {employmentInfo.employment.status}</p>
        <p className="mb-3"><span className="font-medium">Employment Duration:</span> {`${employmentInfo.employment.duration}`}</p>
    </div>
);

export default EmploymentInfoDisplay;